import Accordion from './accordion'
import LazyLoadEmbed from './lazy-load-embed'

import '../scss/base_page.scss'

class Page {
  constructor() {
    document.addEventListener('DOMContentLoaded', () => {
      console.log('[CC+ page online]')

      const lazyLoadEmbed = new LazyLoadEmbed()
      const accordion = new Accordion()
    })
  }
}

export default new Page()
